import { getTgWebApp } from "../tgWebApp"

export const openTgLink = (url: string) => {
  const tgWebApp = getTgWebApp()

  if (tgWebApp?.openTelegramLink) {
    try {
      tgWebApp.openTelegramLink(url)
    } catch (error) {
      console.error(error)
      window.open(url, "_blank")
    }
  } else {
    window.open(url, "_blank")
  }
}
